import { api } from '../services/api'

export const isEmailAvailable = async (
  emailFieldValue: string,
  currentUserEmail?: string,
) => {
  const emailPattern = /^[\w.%+-]+@([\w-]+\.)+[\w]{2,}$/i
  const emailFieldValueInLowerCase = emailFieldValue.toLowerCase()

  if (emailPattern.test(emailFieldValueInLowerCase)) {
    const response = await api.get(
      `/users/email-available/${emailFieldValueInLowerCase}`
    )
    const isEmailAvailable = !response.data

    if (currentUserEmail) {
      return isEmailAvailable || emailFieldValueInLowerCase === currentUserEmail.toLowerCase()
    }

    return isEmailAvailable
  }
}
